const PopupWrapper = ({ children, open }) => {
  return (
    <div
      className={`fixed bg-[rgba(0,0,0,0.4)] flex justify-center items-center transition-all duration-300 ease-in-out bottom-0 ${
        open ? "size-full left-0 z-[100] scale-100 p-4" : "size-0 left-1/2 -z-[100] scale-0"
      }`}
    >
      {children}
    </div>
  );
};

export default PopupWrapper;
